module.exports = __webpack_public_path__ + "img/finland-congenital-and-perinatal-diseases-female.9fbaf770.png";